export const filtersKeyIdValueName = (arr) => {
  return arr.reduce((acc, item) => {
    acc.push({ id: Object.keys(item)[0], name: Object.values(item)[0] });
    return acc;
  }, []);
};
